export const followUpKeys = {
  all: ["followups"],
  queue: (filters) => ["followups", "queue", filters],
  history: (sponsorshipId) => ["followups", "history", sponsorshipId],
  meta: (params) => ["followups", "meta", params],
  calendar: (params) => ["followups", "calendar", params],
  analytics: (params) => ["followups", "analytics", params],
  analyticsDetail: (params) => ["followups", "analytics", "detail", params],
};
